'use strict';
import angular from 'angular';
import ngAnimate from 'angular-animate';
import NavbarController from './navbar.controller';
import NavbarService from './navbar.service';
import CartService from '../../app/cart/cart.service';
import { OrderService } from '../../app/account/orders/order.service';
import SearchBox from '../search-box';
import sticky from './ngSticky';
import util from '../util/util.module';
import ngMaterial from 'angular-material';
import dialog from '../dialog';
import toggleClass from './toggleClass';
import AngularClickOutside from '../angular-click-outside';
import EducationSubNavService from '../education-sub-nav/education-sub-nav.service';
export default angular.module('directives.navbar', [sticky, ngAnimate, ngMaterial, dialog, toggleClass, AngularClickOutside, util, SearchBox])
    .controller('NavbarController', NavbarController)
    .service('EducationSubNavService', EducationSubNavService)
    .service('NavbarService', NavbarService)
    .service('CartService', CartService)
    .service('OrderService', OrderService)
    .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarController
})
    .filter('keyboardShortcut', function ($window) {
    return function (str) {
        if (!str)
            return;
        var keys = str.split('-');
        var isOSX = /Mac OS X/.test($window.navigator.userAgent);
        var seperator = (!isOSX || keys.length > 2) ? '+' : '';
        var abbreviations = {
            M: isOSX ? '⌘' : 'Ctrl',
            A: isOSX ? 'Option' : 'Alt',
            S: 'Shift'
        };
        return keys.map(function (key, index) {
            var last = index == keys.length - 1;
            return last ? key : abbreviations[key];
        }).join(seperator);
    };
})
    .run(function ($rootScope) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
        var currentState = next.name;
        var navBar = document.getElementById('navbar') || {};
        var classList = navBar.classList || { add: function () { }, remove: function () { } };
        if (currentState != 'homepage') {
            classList.remove("homepageStyle");
        }
        else {
            classList.add("homepageStyle");
        }
    });
})
    .directive('svgPng', function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            if (typeof Modernizr !== 'undefined' && !Modernizr.svg) {
                elem.attr('src', attrs.src.replace('.svg', '.png'));
            }
        }
    };
})
    .name;
//# sourceMappingURL=index.js.map